import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
//components
import { Box, makeStyles } from "@material-ui/core";
import { FTLJsonLogger, FTLLoader } from "ftl-uikit";
import { useValidationErrorSnackbar, FTLObjectUtils, useShortcut, FTLShortcutUtils, } from "ftl-core";
import { useHistory } from "react-router-dom";
FTLShortcutUtils.register("goBack", {
    default: "Escape",
    label: "Вернуться назад",
});
const loader = _jsx(FTLLoader, { height: "50vh" }, void 0);
export default ({ formik, children, headerComponent, toolbarComponent, hideLogger, isFetching, }) => {
    useValidationErrorSnackbar({
        condition: formik.isSubmitting && !formik.isValid && formik.submitCount >= 1,
        message: FTLObjectUtils.getFirstPrimitiveValue(formik.errors, "string") ||
            undefined,
    });
    const history = useHistory();
    const { root } = useStyles();
    useShortcut("goBack", history.goBack);
    return (_jsxs("div", Object.assign({ className: root }, { children: [_jsxs(Box, Object.assign({ marginBottom: "auto" }, { children: [headerComponent, !hideLogger && (_jsxs(_Fragment, { children: [_jsx(FTLJsonLogger, { label: "\u0421\u0442\u0435\u0439\u0442 \u0444\u043E\u0440\u043C\u044B", value: formik.values }, void 0), _jsx(FTLJsonLogger, { label: "\u041E\u0448\u0438\u0431\u043A\u0438 \u0444\u043E\u0440\u043C\u044B", value: formik.errors }, void 0)] }, void 0)), isFetching ? (loader) : (_jsx(Suspense, Object.assign({ fallback: loader }, { children: children }), void 0))] }), void 0), toolbarComponent] }), void 0));
};
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        marginRight: theme.spacing(15),
        marginLeft: theme.spacing(15),
        [theme.breakpoints.down("sm")]: { marginRight: 0, marginLeft: 0 },
    },
}));
//# sourceMappingURL=FTLDetailPage.js.map